/**
 * E.164 mobile-number schema — the login identity per DOC1 §7.3.
 * Stored as PII; never logged in plain.
 */
import { z } from 'zod';
export const E164MobileSchema = z
    .string()
    .regex(/^\+\d{10,15}$/, 'mobile must be E.164 (e.g. +14155551234)');
//# sourceMappingURL=mobile.js.map